{
  "removeButtonLabel": "إزالة",
  "removeDescription": "اضغط على مفتاح DELETE لإزالة علامة."
}
